import Message from 'owa-service/lib/contract/Message';

/**
 * This method checks if given response action type exists in the ResponseActions array of the Item
 * @param actionType - action type
 * @param message - message item for which the action types are to be checked
 */
export default function doesItemResponseActionsHasGivenAction(
    actionType: string,
    message: Message
): boolean {
    return (
        message.ResponseObjects && message.ResponseObjects.some(obj => obj.__type === actionType)
    );
}
